
    <button class="button" [type]="buttonType" (click)="handleClicked($event)">
      <lib-icon class="icon" [icon]="icon" [altText]="iconAlt"></lib-icon>
    </button>
  